import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initLocale } from './i18n';
import { installApp } from './lib/app';
import { installEmbed } from './lib/embed';
import { installMarkDraw } from './lib/markDraw';
import { installNarrowFit } from './lib/narrow';
import { installResizeCalm } from './lib/resizing';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

installApp();
installEmbed();
installMarkDraw();
installResizeCalm();
installNarrowFit();

// the language is chosen before the first render, so the page never flashes in English
void initLocale().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
